import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Signup.css'

function Index() {
  const navigate = useNavigate()

  return (
    <div className="SignUp">
      <button onClick={() => navigate('/contact')}>
        SIGN UP
      </button>

      <p>FOR ALL ACCESS</p>
    </div>
  )
}

export default Index
